import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import down from "../assets/logo/down.png";
import DownBoxSvg from "../components/downBoxSvg";
import { useState } from "react";
import MacOS from "./svg/macOS";
import Windows from "./svg/windows";
import Android from "./svg/android";
import QRCode from 'qrcode.react';

const Text = styled("div")(() => ({
  marginTop: 20,
  color: "#fff",
  fontSize: 29.09,
  fontWeight: 700,
  textAlign: 'center'
}));

const downBoxItem = (theme)=> {
  return {
    [theme.breakpoints.up("xl")]: {
      transform: 'scale(1)'
    },
    [theme.breakpoints.down("xl")]: {
      transform: 'scale(1)'
    },
    [theme.breakpoints.down("lg")]: {
      transform: 'scale(0.75)'
    },
    [theme.breakpoints.down("md")]: {
      transform: 'scale(0.75)'
    },
    [theme.breakpoints.down("sm")]: {
      transform: 'scale(0.5)'
    },
    [theme.breakpoints.down("xs")]: {
      transform: 'scale(0.5)',
      '& > div': {
        marginRight: 4
      }
    },
  }
}

const BoxOuter = styled(Box)(({theme}) => ({
  display: "flex",
  flexWrap: "wrap",
  position: "relative",
  ...downBoxItem(theme)
}));

const DownBox = styled("div")(({theme}) => ({
  position: "relative"
}));

const DownBoxItem = styled("div")(({theme}) => ({
  position: "relative"
}));

const flexCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const downLogCss = {
  width: 240,
  height: 80,
  margin: "0 12px"
};

const systemBoxCss = {
  ...flexCenter,
  flexDirection: "column",
};

const systemPicCss = {
  width: 71,
  height: 71,
};

function DownFooterWeb({
  bgColor,
  qrBgColor,
  qrcode,
  showMac = true,
  showWin = true,
  showAndriod = true,
  urlName,
  url1,
  url2,
  u1,
  u2,
  u3,
  u4
}) {
  const DonwBoxCss = {
    width: 240,
    height: 240,
    bgcolor: bgColor,
    borderRadius: "24px",
    position: "relative",
    ...flexCenter,
  };
  let { t } = useTranslation();
  let [zIndex, setZIndex] = useState(-6);
  const showDownScanCode = () => {
    setZIndex(10);
  };
  const hideDownScanCode = () => {
    setZIndex(-6);
  };
  const baseUrl = 'https://download.pharmaciespos.com/devpackage/' + urlName
  const macUrl = baseUrl + '.ipa'
  const winUrl = baseUrl + '.exe'
  const andUrl = baseUrl + '.apk'
  return (
    <BoxOuter sx={{ display: "flex" }}>
      <a href={url1} target="downloadFile" download><img src={u1} style={downLogCss} alt="" /></a>
      <a href={url2} target="downloadFile" download><img src={u2} style={downLogCss} alt="" /></a>
      {
        showWin ?
        <a href={winUrl} target="downloadFile" download>
          <img src={u3} style={downLogCss} alt="" />
        </a>
        : null
      }
      <a href={andUrl} target="downloadFile" download>
        <img src={u4} style={downLogCss} alt="" />
      </a>
    </BoxOuter>
  );
}
export default DownFooterWeb;
